var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.customHtml && _vm.loaded)?_c(_vm.dynamicComponent,{tag:"component"}):(_vm.loaded)?_c('new-programme',{attrs:{"user-programme":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }